import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/headerSaude';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import FormSaude from '../../../components/saude/conferencia';


function SaudeScreen() {
    return (
        <Fragment>
            <Head titulo="Cadastro para a Conferência Municipal de Saúde" />
            <Header />
            <Container>
               <FormSaude /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default SaudeScreen;